// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"eb60146d9aebcb67","9032":"896a99436829266c"}[chunkId] + ".css";
};